module.exports = __webpack_public_path__ + "img/mc.b4db69f2.png";